import { EnglishTestPanel } from './EnglishTestPanel'
import { EnglishProficiencyIntro } from './englishProficiency/EnglishProficiencyIntro'
import { EnglishProficiencyResult } from './englishProficiency/EnglishProficiencyResult'
import type { EnglishProficiencyStepProps } from './englishProficiency/types'
import { useEnglishProficiencyFlow } from './englishProficiency/useEnglishProficiencyFlow'

export function EnglishProficiencyStep({
  onNext,
  onBack,
  onPassed,
  currentStep,
  totalSteps,
  enrollment
}: EnglishProficiencyStepProps) {
  const {
    assessmentId,
    continueError,
    defaultTest,
    effectiveTestResult,
    handleCloseTest,
    handleResultAction,
    handleStartTest,
    handleTestComplete,
    initialAssessmentAnswers,
    isRetryLockout,
    isStartingTest,
    isTestModalOpen,
    resultButtonLabel,
    resultButtonLoading,
    retryLockoutMessage,
    showResultScreen,
    startTestError,
    testPassed
  } = useEnglishProficiencyFlow({
    enrollment,
    onNext,
    onPassed
  })

  return (
    <>
      {!showResultScreen && !isTestModalOpen ? (
        <EnglishProficiencyIntro
          currentStep={currentStep}
          totalSteps={totalSteps}
          onBack={onBack}
          onStartTest={() => {
            void handleStartTest()
          }}
          isStartingTest={isStartingTest}
          startTestError={startTestError}
        />
      ) : null}

      {!showResultScreen && isTestModalOpen ? (
        <EnglishTestPanel
          currentStep={currentStep}
          totalSteps={totalSteps}
          onBack={onBack}
          isOpen={isTestModalOpen}
          onClose={handleCloseTest}
          onComplete={handleTestComplete}
          assessmentId={assessmentId}
          defaultTest={defaultTest}
          initialAnswers={initialAssessmentAnswers}
        />
      ) : null}

      {showResultScreen ? (
        <EnglishProficiencyResult
          continueError={continueError}
          currentStep={currentStep}
          effectiveTestResult={effectiveTestResult}
          isRetryLockout={isRetryLockout}
          onAction={() => {
            void handleResultAction()
          }}
          onBack={onBack}
          resultButtonLabel={resultButtonLabel}
          resultButtonLoading={resultButtonLoading}
          retryLockoutMessage={retryLockoutMessage}
          testPassed={testPassed}
          totalSteps={totalSteps}
        />
      ) : null}
    </>
  )
}
